import { render, staticRenderFns } from "./WordPage.vue?vue&type=template&id=1f7de8b7&scoped=true"
import script from "./WordPage.vue?vue&type=script&lang=js"
export * from "./WordPage.vue?vue&type=script&lang=js"
import style0 from "./WordPage.vue?vue&type=style&index=0&id=1f7de8b7&prod&lang=scss&scoped=true"
import style1 from "./WordPage.vue?vue&type=style&index=1&id=1f7de8b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7de8b7",
  null
  
)

export default component.exports